import React from "react";
import RotatingMessageLoader from "Components/common/RotatingMessageLoader";
import { observable, action } from "mobx";
import { observer } from "mobx-react";

const defaultPopupValues = {
  msg: "",
  title: "Add Contact"
};

class ContactUploadingToSequencePopupState {
  @observable showPopup = false;
  @observable popupValues = defaultPopupValues;

  @action
  setShowPopup = value => {
    this.showPopup = value;
  };

  @action
  setPopupValues = obj => {
    this.popupValues = { ...this.popupValues, ...obj };
  };

  @action
  resetPopup = () => {
    this.showPopup = false;
    this.popupValues = defaultPopupValues;
  };
}

const contactUploadingToSequencePopupState =
  new ContactUploadingToSequencePopupState();

const ContactUploadingToSequence = observer(props => {
  const { msg = "", title = "Add Contact" } =
    contactUploadingToSequencePopupState?.popupValues || {};
  return (
    (contactUploadingToSequencePopupState?.showPopup && (
      <div className="sequenceContactUploader">
        <div className="contactUploader">
          <h3>{title}</h3>
          <RotatingMessageLoader
            variant="inline"
            messages={[
              msg || "Adding contacts to the sequence…",
              "Validating contact details…",
              "Assigning contacts to sequence steps…",
              "Almost done…"
            ]}
            hint="This may take a few seconds. Please keep this window open."
          />
        </div>
        <div className="contactUploaderOverlay" />
      </div>
    )) ||
    ""
  );
});

export default ContactUploadingToSequence;
export { ContactUploadingToSequence, contactUploadingToSequencePopupState };
